export default __webpack_public_path__ + "static/media/colombia1.2c534d63.png";